import { OnboardingData } from '../types/onboarding';

export function buildAnalyticsData(
  data: OnboardingData,
  legalMap: Record<string, { name: string }>,
  sectorMap: Record<string, { class_title?: string }>,
) {
  const legal_structure_name = data.formData.legal_structure
    ? (legalMap?.[data.formData.legal_structure]?.name ?? '')
    : '';

  const industry_sector_names =
    data.formData.industry_sector
      ?.map((id) => sectorMap?.[id]?.class_title)
      .filter((name): name is string => !!name) ?? [];

  return { ...data, legal_structure_name, industry_sector_names };
}
